import React from 'react'

export default function MinHeightDecorator({ children }) {
  // 100vh - header - subnav for minHeight to not have footer show and hide straight away. We do not include the 1px divider so that the scroller stays up
  return <div style={{ minHeight: 'calc(100vh - 60px - 52px)' }}>{children}</div>
}
